export default __webpack_public_path__ + "static/media/slide_05.aba2d4d1.png";